var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { class: [_vm.theme === 1 ? "" : "theme-2"] },
        [
          _c("notifications", { attrs: { group: "foo" } }),
          _vm.currentJewelSelection &&
          _vm.currentJewelSelection.name &&
          !_vm.isSearching
            ? _c(
                "div",
                [
                  !_vm.buildYourJewelMode ? _c("Breadcrumb") : _vm._e(),
                  _vm.isAma
                    ? _c(
                        "div",
                        [
                          _c("DetailAma"),
                          _c("ring-settings", {
                            ref: "ringSettings",
                            on: {
                              changeFastDelivery: function($event) {
                                _vm.quantity = 1
                                _vm.setQuantity(1)
                              },
                              changeSettings: function($event) {
                                return _vm.resetSwiperIndex()
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.isAma &&
                  _vm.currentJewelSelection &&
                  !!_vm.currentJewelSelection.name &&
                  !_vm.isSearching
                    ? _c(
                        "div",
                        { staticClass: "col d-inline-flex px-0 mt-4 row" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-12 col-md-6 text-left pl-md-0 order-2",
                              class: [_vm.theme === 1 ? "order-md-1" : ""]
                            },
                            [
                              _c("div", { staticClass: "col-12" }, [
                                _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    {
                                      class: [
                                        _vm.theme === 1 ? "col-md-7" : "p-3"
                                      ],
                                      staticStyle: { "z-index": "2" }
                                    },
                                    [
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "jewel-name title mb-0 pl-5 w-100"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.currentJewelSelection.name
                                                ) +
                                                " "
                                            )
                                          ]
                                        ),
                                        _c("p", {
                                          staticClass:
                                            "text-break w-100 jewel-description pl-5",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.jewelDescription
                                            )
                                          }
                                        })
                                      ]),
                                      _vm._l(_vm.selectedStones, function(
                                        selectedStone
                                      ) {
                                        return _vm.buildYourJewelMode
                                          ? _c("div", { staticClass: "row" }, [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "jewel-name title mb-0 pl-5 w-100"
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        selectedStone.cartItem
                                                          .name
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              ),
                                              _c("p", {
                                                staticClass:
                                                  "text-break w-100 jewel-description pl-5",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    selectedStone.cartItem
                                                      .description
                                                  )
                                                }
                                              })
                                            ])
                                          : _vm._e()
                                      }),
                                      _c("ring-settings", {
                                        ref: "ringSettings",
                                        on: {
                                          changeFastDelivery: function($event) {
                                            _vm.quantity = 1
                                            _vm.setQuantity(1)
                                          },
                                          changeSettings: function($event) {
                                            return _vm.resetSwiperIndex()
                                          }
                                        }
                                      })
                                    ],
                                    2
                                  ),
                                  _vm.theme === 1
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-md-5 p-0 pr-md-3 pl-md-3 col-right"
                                        },
                                        [
                                          ((_vm.imagesAvailable &&
                                            _vm.imagesAvailable.length > 1) ||
                                            (_vm.videos &&
                                              _vm.videos.length > 0)) &&
                                          _vm.jewelDescription
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-none d-md-block"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "swiper",
                                                          rawName:
                                                            "v-swiper:swiperThumbs",
                                                          value:
                                                            _vm.swiperThumbsOptions,
                                                          expression:
                                                            "swiperThumbsOptions",
                                                          arg: "swiperThumbs"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "px-1 pt-2 swiper-thumbs swiper-thumbs-desktop"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "swiper-wrapper"
                                                        },
                                                        [
                                                          _vm._l(
                                                            _vm.imagesAvailable,
                                                            function(
                                                              image,
                                                              index
                                                            ) {
                                                              return _c(
                                                                "div",
                                                                {
                                                                  key: image,
                                                                  staticClass:
                                                                    "swiper-slide",
                                                                  class: {
                                                                    active:
                                                                      index ==
                                                                      _vm.thumbsActiveIndex
                                                                  }
                                                                },
                                                                [
                                                                  _c("img", {
                                                                    staticClass:
                                                                      "border-img",
                                                                    attrs: {
                                                                      src:
                                                                        _vm.baseImageUrl +
                                                                        image
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.slideSwiperTopTo(
                                                                          index
                                                                        )
                                                                      }
                                                                    }
                                                                  })
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          _vm._l(
                                                            _vm.videos,
                                                            function(
                                                              video,
                                                              viedoIndex
                                                            ) {
                                                              return _vm.videos &&
                                                                _vm.videos
                                                                  .length > 0
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "swiper-slide",
                                                                      class: {
                                                                        active:
                                                                          _vm
                                                                            .imagesAvailable
                                                                            .length +
                                                                            viedoIndex ==
                                                                          _vm.thumbsActiveIndex
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "img",
                                                                        {
                                                                          staticClass:
                                                                            "border-img video-icon",
                                                                          attrs: {
                                                                            src: require("../assets/video-icon.png")
                                                                          },
                                                                          on: {
                                                                            click: function(
                                                                              $event
                                                                            ) {
                                                                              return _vm.slideSwiperTopTo(
                                                                                _vm
                                                                                  .imagesAvailable
                                                                                  .length +
                                                                                  viedoIndex
                                                                              )
                                                                            }
                                                                          }
                                                                        }
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            }
                                                          )
                                                        ],
                                                        2
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "div",
                                            { staticClass: "col-price" },
                                            [
                                              _vm.selectedJewel &&
                                              _vm.selectedJewel.placeholders &&
                                              (_vm.selectedJewel.placeholders
                                                .tctmix ||
                                                _vm.selectedJewel.placeholders
                                                  .tctpst) &&
                                              (_vm.selectedJewel.placeholders.tctmix.replace(
                                                /,/,
                                                "."
                                              ) > 0 ||
                                                _vm.selectedJewel.placeholders.tctpst.replace(
                                                  /,/,
                                                  "."
                                                ) > 0)
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "ml-md-2 mb-3 mt-3 mt-md-0"
                                                    },
                                                    [
                                                      !_vm.buildYourJewelMode
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "price-info border-left-0"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "label-menu text-uppercase pl-md-2 pl-5"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "totalCarat"
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  )
                                                                ]
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "w-100 label-menu text-right pl-2 pr-md-2 pr-5"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        (_vm.selectedJewel.placeholders.tctmix.replace(
                                                                          /,/,
                                                                          "."
                                                                        ) > 0
                                                                          ? _vm
                                                                              .selectedJewel
                                                                              .placeholders
                                                                              .tctmix
                                                                          : _vm
                                                                              .selectedJewel
                                                                              .placeholders
                                                                              .tctpst) +
                                                                          " " +
                                                                          _vm.$t(
                                                                            "ct"
                                                                          )
                                                                      ) +
                                                                      " "
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                : _vm._e(),
                                              !_vm.buildYourJewelMode
                                                ? _c(
                                                    "div",
                                                    { staticClass: "ml-md-2" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "price-info border-left-0"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "w-100"
                                                            },
                                                            [
                                                              _c(
                                                                "p",
                                                                {
                                                                  staticClass:
                                                                    "\n                          text-left\n                          mb-0\n                          pl-md-2 pl-5\n                          text-uppercase\n                          label-menu\n                        "
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "quantity"
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  )
                                                                ]
                                                              ),
                                                              _vm.fastDelivery
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "pl-md-2 pl-5 text-left pieces-label"
                                                                    },
                                                                    [
                                                                      _vm
                                                                        .selectedJewel
                                                                        .availability ==
                                                                      1
                                                                        ? _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  _vm
                                                                                    .selectedJewel
                                                                                    .availability
                                                                                ) +
                                                                                  " " +
                                                                                  _vm._s(
                                                                                    _vm.$t(
                                                                                      "pieceAvailable"
                                                                                    )
                                                                                  )
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      _vm
                                                                        .selectedJewel
                                                                        .availability >
                                                                      1
                                                                        ? _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  _vm
                                                                                    .selectedJewel
                                                                                    .availability
                                                                                ) +
                                                                                  " " +
                                                                                  _vm._s(
                                                                                    _vm.$t(
                                                                                      "piecesAvailable"
                                                                                    )
                                                                                  )
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e()
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "w-100 text-right pl-2 pr-md-0 pr-5"
                                                            },
                                                            [
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm.quantity,
                                                                    expression:
                                                                      "quantity"
                                                                  }
                                                                ],
                                                                staticClass:
                                                                  "text-center input-quantity",
                                                                attrs: {
                                                                  type:
                                                                    "number",
                                                                  step: "1",
                                                                  min: "1",
                                                                  max: _vm.fastDelivery
                                                                    ? _vm
                                                                        .selectedJewel
                                                                        .availability
                                                                    : 1000
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm.quantity
                                                                },
                                                                on: {
                                                                  change:
                                                                    _vm.changeQuantity,
                                                                  input: function(
                                                                    $event
                                                                  ) {
                                                                    if (
                                                                      $event
                                                                        .target
                                                                        .composing
                                                                    ) {
                                                                      return
                                                                    }
                                                                    _vm.quantity =
                                                                      $event.target.value
                                                                  }
                                                                }
                                                              })
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "div",
                                                { staticClass: "ml-md-2" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "price-info jewel-value"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "w-100"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "\n                          text-left\n                          pl-md-2 pl-5\n                          text-uppercase\n                          label-menu\n                          price-label\n                        "
                                                            },
                                                            [
                                                              _vm.credential
                                                                .apiEncryptedUser ||
                                                              !_vm.averageOrVatPriceVisible
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "jewelValue"
                                                                        )
                                                                      )
                                                                    )
                                                                  ])
                                                                : _vm._e(),
                                                              !_vm.credential
                                                                .apiEncryptedUser &&
                                                              _vm.averageOrVatPriceVisible
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "discountedPrice"
                                                                        )
                                                                      )
                                                                    )
                                                                  ])
                                                                : _vm._e()
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "w-100 text-right"
                                                        },
                                                        [
                                                          _vm.basePrice
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "price-value pr-md-2 pr-5"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.priceValue
                                                                      ) +
                                                                      "€ "
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "price-info mb-2"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "w-100"
                                                        },
                                                        [
                                                          _vm.averageOrVatPriceVisible &&
                                                          _vm.credential
                                                            .apiEncryptedUser
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "average-price text-left pl-md-2 pl-5"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "averagePrice"
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          !_vm.credential
                                                            .apiEncryptedUser &&
                                                          _vm.averageOrVatPriceVisible
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "average-price text-left pl-md-2 pl-5"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "jewelValue"
                                                                      )
                                                                    ) + " "
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "w-100 text-right pr-md-2 pr-5"
                                                        },
                                                        [
                                                          _vm.averageOrVatPriceVisible
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "average-price",
                                                                  staticStyle: {
                                                                    "text-decoration":
                                                                      "line-through"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.averageOrVatPriceValue
                                                                      ) +
                                                                      " € "
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "price-info mb-2",
                                                      class: {
                                                        "bg-fastDelivery":
                                                          _vm.fastDelivery
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "\n                          text-left\n                          pl-md-2 pl-5\n                          w-100\n                          delivery-label\n                        "
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "plannedShipment"
                                                                )
                                                              ) +
                                                              " "
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "w-100 text-right pl-2 pr-md-2 pr-5"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "delivery-label"
                                                            },
                                                            [
                                                              _vm.selectedJewel
                                                                .shipmentDate
                                                                ? _c("span", [
                                                                    _vm.logo ||
                                                                    _vm.writing
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm
                                                                                  .selectedJewel
                                                                                  .engravingDate
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm.fastDelivery
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm
                                                                                  .currentJewelSelection
                                                                                  .fastDeliveryDate
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm.credential &&
                                                                        !_vm
                                                                          .credential
                                                                          .apiEncryptedUser
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm
                                                                                  .selectedJewel
                                                                                  .b2cDeliveryDate
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm
                                                                                  .selectedJewel
                                                                                  .shipmentDate
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                  ])
                                                                : _vm._e()
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm.credential.apiEncryptedUser
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "ml-md-2 mb-2"
                                                    },
                                                    [
                                                      _c("textarea", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value: _vm.note,
                                                            expression: "note"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "item-note",
                                                        attrs: {
                                                          placeholder: _vm.$t(
                                                            "note.placeholder"
                                                          )
                                                        },
                                                        domProps: {
                                                          value: _vm.note
                                                        },
                                                        on: {
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.note =
                                                              $event.target.value
                                                          }
                                                        }
                                                      })
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "div",
                                                { staticClass: "ml-md-2" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "col-12 px-0"
                                                    },
                                                    [
                                                      _vm.isAmuleto
                                                        ? _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "amuleto-warning text-uppercase mb-2"
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "amuletoMinOrderWarning"
                                                                    )
                                                                  ) +
                                                                  " "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "btn text-uppercase rounded-btn w-100",
                                                          class: [
                                                            _vm.addedToBasket
                                                              ? "btn-secondary-" +
                                                                _vm.theme
                                                              : "btn-primary-" +
                                                                _vm.theme
                                                          ],
                                                          attrs: {
                                                            id: "basketbtn",
                                                            disabled:
                                                              !_vm.jewelDescription ||
                                                              _vm.addedToBasket ||
                                                              _vm.quantity <
                                                                1 ||
                                                              _vm.quantity ===
                                                                "0" ||
                                                              (_vm.fastDelivery &&
                                                                _vm.quantity >
                                                                  _vm
                                                                    .selectedJewel
                                                                    .availability) ||
                                                              (_vm.$refs
                                                                .ringSettings &&
                                                                _vm.$refs
                                                                  .ringSettings
                                                                  .incisione &&
                                                                !_vm.$refs
                                                                  .ringSettings
                                                                  .incisioneLabel)
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.addToBasket
                                                          }
                                                        },
                                                        [
                                                          _vm.addedToBasket
                                                            ? _c("span", {}, [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "addedToBasket"
                                                                    )
                                                                  )
                                                                )
                                                              ])
                                                            : _c("span", {}, [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "addToBasket"
                                                                    )
                                                                  )
                                                                )
                                                              ])
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.theme === 2
                                    ? _c(
                                        "div",
                                        { staticClass: "col-12 mt-5" },
                                        [
                                          _c("div", { staticClass: "row" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-md-7",
                                                staticStyle: { "z-index": "1" }
                                              },
                                              [
                                                _vm.selectedJewel &&
                                                _vm.selectedJewel
                                                  .placeholders &&
                                                (_vm.selectedJewel.placeholders
                                                  .tctmix ||
                                                  _vm.selectedJewel.placeholders
                                                    .tctpst) &&
                                                (_vm.selectedJewel.placeholders.tctmix.replace(
                                                  /,/,
                                                  "."
                                                ) > 0 ||
                                                  _vm.selectedJewel.placeholders.tctpst.replace(
                                                    /,/,
                                                    "."
                                                  ) > 0)
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "row ml-md-2 mb-3"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-12 col-lg-8 p-0"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "price-info border-left-0"
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "w-100 label-menu text-uppercase pl-md-2 pl-5"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "totalCarat"
                                                                          )
                                                                        ) +
                                                                        " "
                                                                    )
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "w-100 label-menu text-right pl-2 pr-md-2 pr-5"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          (_vm.selectedJewel.placeholders.tctmix.replace(
                                                                            /,/,
                                                                            "."
                                                                          ) > 0
                                                                            ? _vm
                                                                                .selectedJewel
                                                                                .placeholders
                                                                                .tctmix
                                                                            : _vm
                                                                                .selectedJewel
                                                                                .placeholders
                                                                                .tctpst) +
                                                                            " " +
                                                                            _vm.$t(
                                                                              "ct"
                                                                            )
                                                                        ) +
                                                                        " "
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "row ml-md-2"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-12 col-lg-8 p-0"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "price-info"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "w-100 pl-0"
                                                              },
                                                              [
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "\n                              text-left\n                              mb-0\n                              pl-md-2 pl-5\n                              text-uppercase\n                              label-menu\n                            "
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "quantity"
                                                                          )
                                                                        ) +
                                                                        " "
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "w-100 pl-0 text-right"
                                                              },
                                                              [
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm.quantity,
                                                                      expression:
                                                                        "quantity"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "text-center input-quantity",
                                                                  attrs: {
                                                                    type:
                                                                      "number",
                                                                    step: "1",
                                                                    min: "0"
                                                                  },
                                                                  domProps: {
                                                                    value:
                                                                      _vm.quantity
                                                                  },
                                                                  on: {
                                                                    change:
                                                                      _vm.changeQuantity,
                                                                    input: function(
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.quantity =
                                                                        $event.target.value
                                                                    }
                                                                  }
                                                                })
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _c("br")
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "col-md-5" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "row ml-md-2"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "col-12" },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "price-info row border-left-0",
                                                            class: {
                                                              "bg-fastDelivery":
                                                                _vm.fastDelivery
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-6 pl-0 d-inline-block position-relative"
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "\n                              text-left\n                              pl-md-2 pl-5\n                              text-uppercase\n                              label-menu\n                              avg-price-label\n                            "
                                                                  },
                                                                  [
                                                                    _vm
                                                                      .credential
                                                                      .apiEncryptedUser ||
                                                                    !_vm.averageOrVatPriceVisible
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "jewelValue"
                                                                                )
                                                                              ) +
                                                                                ":"
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    !_vm
                                                                      .credential
                                                                      .apiEncryptedUser &&
                                                                    _vm.averageOrVatPriceVisible
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "discountedPrice"
                                                                                )
                                                                              ) +
                                                                                ":"
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e()
                                                                  ]
                                                                ),
                                                                _vm.averageOrVatPriceVisible &&
                                                                _vm.credential
                                                                  .apiEncryptedUser
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "average-price text-left pl-md-2 pl-5"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "averagePrice"
                                                                              )
                                                                            ) +
                                                                            ": "
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-6"
                                                              },
                                                              [
                                                                _vm.basePrice
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "float-right price-value"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.priceValue
                                                                            ) +
                                                                            " € "
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                                _vm.averageOrVatPriceVisible
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "average-price float-right",
                                                                        staticStyle: {
                                                                          "text-decoration":
                                                                            "line-through"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.averageOrVatPriceValue
                                                                            ) +
                                                                            " € "
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _c("br")
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "row ml-md-2"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-12 px-0"
                                                      },
                                                      [
                                                        _vm.isAmuleto
                                                          ? _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "amuleto-warning text-uppercase mb-2"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "amuletoMinOrderWarning"
                                                                      )
                                                                    ) +
                                                                    " "
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "btn text-uppercase rounded-btn w-100",
                                                            class: [
                                                              _vm.addedToBasket
                                                                ? "btn-secondary-" +
                                                                  _vm.theme
                                                                : "btn-primary-" +
                                                                  _vm.theme
                                                            ],
                                                            attrs: {
                                                              id: "basketbtn",
                                                              disabled:
                                                                !_vm.jewelDescription ||
                                                                _vm.addedToBasket ||
                                                                _vm.quantity <
                                                                  1 ||
                                                                _vm.quantity ===
                                                                  "0" ||
                                                                (_vm.fastDelivery &&
                                                                  _vm.quantity >
                                                                    _vm
                                                                      .selectedJewel
                                                                      .availability) ||
                                                                (_vm.$refs
                                                                  .ringSettings &&
                                                                  _vm.$refs
                                                                    .ringSettings
                                                                    .incisione &&
                                                                  !_vm.$refs
                                                                    .ringSettings
                                                                    .incisioneLabel)
                                                            },
                                                            on: {
                                                              click:
                                                                _vm.addToBasket
                                                            }
                                                          },
                                                          [
                                                            _vm.addedToBasket
                                                              ? _c("span", {}, [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "addedToBasket"
                                                                      )
                                                                    )
                                                                  )
                                                                ])
                                                              : _c("span", {}, [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "addToBasket"
                                                                      )
                                                                    )
                                                                  )
                                                                ])
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "mt-3 text-right"
                                                          },
                                                          [
                                                            _vm.selectedJewel
                                                              .shipmentDate
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "delivery-label"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "plannedShipment"
                                                                        )
                                                                      ) + " "
                                                                    ),
                                                                    _vm.logo ||
                                                                    _vm.writing
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm
                                                                                  .selectedJewel
                                                                                  .engravingDate
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm.fastDelivery
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm
                                                                                  .currentJewelSelection
                                                                                  .fastDeliveryDate
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm.credential &&
                                                                        !_vm
                                                                          .credential
                                                                          .apiEncryptedUser
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm
                                                                                  .selectedJewel
                                                                                  .b2cDeliveryDate
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm
                                                                                  .selectedJewel
                                                                                  .shipmentDate
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              ])
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "col-12 col-md-6 order-1",
                              class: [_vm.theme === 1 ? "order-md-2" : ""]
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "d-md-none text-left" },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "font-weight-bold w-100 jewel-name mb-0 title-font"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.currentJewelSelection.name
                                          ) +
                                          " "
                                      )
                                    ]
                                  ),
                                  _c("p", {
                                    staticClass:
                                      "text-break w-100 jewel-description",
                                    domProps: {
                                      innerHTML: _vm._s(_vm.jewelDescription)
                                    }
                                  })
                                ]
                              ),
                              _vm.selectedSku
                                ? _c(
                                    "p",
                                    {
                                      staticClass:
                                        "text-left sku text-muted mb-1"
                                    },
                                    [
                                      _vm._v(
                                        " SKU " +
                                          _vm._s(
                                            _vm.selectedSku
                                              ? _vm.selectedSku +
                                                  _vm.additionalSkuLabelArray.join(
                                                    ""
                                                  )
                                              : null
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm.buildYourJewelMode
                                ? _c(
                                    "p",
                                    {
                                      staticClass:
                                        "text-left sku text-muted mb-1 font-weight-bold"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "build_your_jewel.img_warning"
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm.jewelDescription
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "\n            text-center\n            w-100\n            mb-3\n            position-relative\n            border-img-container\n          ",
                                      class: {
                                        "fast-delivery": _vm.fastDelivery
                                      }
                                    },
                                    [
                                      _vm.imagesAvailable &&
                                      _vm.imagesAvailable.length > 0 &&
                                      _vm.jewelDescription
                                        ? _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "swiper",
                                                  rawName: "v-swiper:swiperTop",
                                                  value: _vm.swiperTopOptions,
                                                  expression:
                                                    "swiperTopOptions",
                                                  arg: "swiperTop"
                                                }
                                              ],
                                              staticClass:
                                                "border-img-current w-100",
                                              on: {
                                                slideChange:
                                                  _vm.changeSwiperTopIndex
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "swiper-wrapper"
                                                },
                                                [
                                                  _vm._l(
                                                    _vm.imagesAvailable,
                                                    function(image, index) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: image,
                                                          staticClass:
                                                            "swiper-slide"
                                                        },
                                                        [
                                                          _c("img", {
                                                            staticClass:
                                                              "border-img w-100",
                                                            attrs: {
                                                              src:
                                                                _vm.baseImageUrl +
                                                                image
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  _vm._l(_vm.videos, function(
                                                    video
                                                  ) {
                                                    return _vm.videos &&
                                                      _vm.videos.length > 0
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "swiper-slide"
                                                          },
                                                          [
                                                            _c("video", {
                                                              ref: "videoRef",
                                                              refInFor: true,
                                                              staticClass:
                                                                "video-container",
                                                              attrs: {
                                                                id:
                                                                  "video-container",
                                                                width: "100%",
                                                                src:
                                                                  _vm.baseVideoUrl +
                                                                  video,
                                                                controls: "",
                                                                allowfullscreen:
                                                                  "",
                                                                webkitallowfullscreen:
                                                                  "",
                                                                mozallowfullscreen:
                                                                  "",
                                                                playsinline: ""
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  })
                                                ],
                                                2
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                : _vm._e(),
                              ((_vm.imagesAvailable &&
                                _vm.imagesAvailable.length > 1) ||
                                (_vm.videos && _vm.videos.length > 0)) &&
                              _vm.jewelDescription
                                ? _c("div", [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "swiper",
                                            rawName:
                                              "v-swiper:swiperThumbsMobile",
                                            value:
                                              _vm.swiperThumbsMobileOptions,
                                            expression:
                                              "swiperThumbsMobileOptions",
                                            arg: "swiperThumbsMobile"
                                          }
                                        ],
                                        staticClass: "px-1 pt-2 swiper-thumbs",
                                        class: [
                                          _vm.theme === 1 ? "d-md-none " : ""
                                        ]
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "swiper-wrapper" },
                                          [
                                            _vm._l(
                                              _vm.imagesAvailable,
                                              function(image, index) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: image,
                                                    staticClass: "swiper-slide",
                                                    class: {
                                                      active:
                                                        index ==
                                                        _vm.thumbsActiveIndex
                                                    }
                                                  },
                                                  [
                                                    _c("img", {
                                                      staticClass:
                                                        "border-img w-100 mb-3",
                                                      attrs: {
                                                        src:
                                                          _vm.baseImageUrl +
                                                          image
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.slideSwiperTopTo(
                                                            index
                                                          )
                                                        }
                                                      }
                                                    })
                                                  ]
                                                )
                                              }
                                            ),
                                            _vm._l(_vm.videos, function(
                                              video,
                                              videoIndex
                                            ) {
                                              return _vm.videos &&
                                                _vm.videos.length > 0
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "swiper-slide",
                                                      class: {
                                                        active:
                                                          _vm.imagesAvailable
                                                            .length +
                                                            videoIndex ==
                                                          _vm.thumbsActiveIndex
                                                      }
                                                    },
                                                    [
                                                      _c("img", {
                                                        staticClass:
                                                          "border-img w-100 mb-3 video-icon",
                                                        attrs: {
                                                          src: require("../assets/video-icon.png")
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.slideSwiperTopTo(
                                                              _vm
                                                                .imagesAvailable
                                                                .length +
                                                                videoIndex
                                                            )
                                                          }
                                                        }
                                                      })
                                                    ]
                                                  )
                                                : _vm._e()
                                            })
                                          ],
                                          2
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e()
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "col-12 order-3 mt-5" },
                            [_c("related-jewels")],
                            1
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.isSearching ||
          (_vm.currentJewelSelection && !_vm.currentJewelSelection.name)
            ? _c("div", { staticClass: "col d-inline-flex px-0 mt-4 row" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-12 mb-3 text-center justify-content-center mt-5"
                  },
                  [
                    _c("DoubleBounce", {
                      attrs: { background: "#00274F", size: "100px" }
                    })
                  ],
                  1
                )
              ])
            : _vm._e()
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "info-request-modal",
            title: _vm.$t("requestMoreInfo"),
            "ok-only": "",
            "ok-title": _vm.$t("close"),
            centered: "",
            "modal-class": "info-request-modal"
          }
        },
        [_c("p", [_vm._v(_vm._s(_vm.$t("requestMoreInfoMessage")))])]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }